export default ({ request }) => ({
  ecomAmzAppListApi(data = {}) {
    return request({
      url: '/ecomorder/amz/app/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzAppDetailApi(data = {}) {
    return request({
      url: '/ecomorder/amz/app/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzAppSaveApi(data = {}) {
    return request({
      url: '/ecomorder/amz/app/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzAppDelApi(data = {}) {
    return request({
      url: '/ecomorder/amz/app/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzAppAccountListApi(data = {}) {
    return request({
      url: '/ecomorder/amz/app/account/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzAppAccountDetailApi(data = {}) {
    return request({
      url: '/ecomorder/amz/app/account/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzAppAccountSaveApi(data = {}) {
    return request({
      url: '/ecomorder/amz/app/account/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzAppAccountDelApi(data = {}) {
    return request({
      url: '/ecomorder/amz/app/account/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzAppAccountStoreListApi(data = {}) {
    return request({
      url: '/ecomorder/amz/app/account/store/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzAppAccountStoreOptionsApi(data = {}) {
    return request({
      url: '/ecomorder/amz/app/account/store/options',
      method: 'POST',
      data,
    })
  },
})
